import { createAction, createSlice, PrepareAction } from "@reduxjs/toolkit";

import { persistUser, readUser } from "services/localStorage.service";

export interface UserState {
  user: any | null;
  cred?: boolean | null;
}

const initialState: UserState = {
  user: readUser(),
  cred: null,
};

export const setUser = createAction<PrepareAction<any>>(
  "user/setUser",
  (newUser) => {
    persistUser(newUser);
    return {
      payload: newUser,
    };
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export default userSlice.reducer;
